export default {
    //枚举
    enmu: {

        //行业类型
        enumIndustryType: [{
                key: 0,
                value: '农_林_牧_渔业',
            },
            {
                key: 1,
                value: '工业',
            },
            {
                key: 2,
                value: '建筑业',
            },
            {
                key: 3,
                value: '批发业',
            },
            {
                key: 4,
                value: '零售业',
            },
            {
                key: 5,
                value: '交通运输业',
            },
            {
                key: 6,
                value: '仓储业',
            },
            {
                key: 7,
                value: '邮政业',
            },
            {
                key: 8,
                value: '住宿业',
            },
            {
                key: 9,
                value: '餐饮业',
            },
            {
                key: 10,
                value: '信息运输业',
            },
            {
                key: 11,
                value: '软件和信息技术服务业',
            },
            {
                key: 12,
                value: '房地产开发经营',
            },
            {
                key: 13,
                value: '物业管理',
            },
            {
                key: 14,
                value: '租赁和商务服务',
            },
            {
                key: 15,
                value: '其他未列明行业',
            },

        ],
        //审核状态
        enumPersonStatus: [{
                key: 0,
                value: "待单位初审",
            }, {
                key: 1,
                value: "待受理",
            }, {
                key: 3,
                value: "审批中",
            },
            {
                key: 4,
                value: "待分配房源",
            },
            {
                key: 5,
                value: "待生成合同",
            },
            {
                key: 6,
                value: "待缴纳费用",
            },
            {
                key: 7,
                value: "待合同签章确认",
            },
            {
                key: 8,
                value: "待入住受理",
            },
            {
                key: 9,
                value: "已入住",
            }, {
                key: 11,
                value: "终止",
            },
            {
                key: 12,
                value: "审批不通过",
            },
            {
                key: 23,
                value: "待轮候",
            },
            {
                key: 24,
                value: "轮候中",
            },
            {
                key: 99,
                value: "草稿 ",
            }
        ],
        //合同状态
        enumContractStatus: [{
                key: 0,
                value: "未生成",
            }, {
                key: 1,
                value: "未签章",
            }, {
                key: 2,
                value: "未生效",
            }, {
                key: 3,
                value: "有效 ",
            }, {
                key: 4,
                value: "失效"
            }, {
                key: 5,
                value: "解除",
            }, {
                key: 6,
                value: "提前废止  ",
            }, {
                key: 7,
                value: "作废"
            }


        ],
        //入住类型
        enumCheckInType: [{
                key: 0,
                value: "正常入住",
            }, {
                key: 1,
                value: " 换房入住",
            }


        ],
        //职称
        TITLE: [{
            key: 1,
            value: "无"
        }, {
            key: 2,
            value: "初级"
        }, {
            key: 3,
            value: "中级"
        }, {
            key: 4,
            value: "高级"
        }],
        //政治面貌
        enumPOLITICALSTATUS: [{
            key: 13,
            value: "     群众"
        }, {
            key: 1,
            value: " 中共党员"
        }, {
            key: 2,
            value: "中共预备党员"
        }, {
            key: 3,
            value: "    共青团员"
        }, {
            key: 4,
            value: "民革会员"
        }, {
            key: 5,
            value: "   民盟盟员 "
        }, {
            key: 6,
            value: "民建会员 "
        }, {
            key: 7,
            value: "    民进会员"
        }, {
            key: 8,
            value: "  农工党党员"
        }, {
            key: 9,
            value: "  致公党党员"
        }, {
            key: 10,
            value: "     九三学社社员 "
        }, {
            key: 11,
            value: "      台盟盟员  "
        }, {
            key: 12,
            value: "       无党派人士"
        }],
        //房源性质
        // roomPropertyList: [{
        //     id: 2,
        //     name: "人才公寓",
        // }, {
        //     id: 5,
        //     name: "职工公寓"
        // }]


    }
}